
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { Link } from 'react-router-dom';

const ServicesOverview = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const services = [
    {
      icon: 'ri-briefcase-line',
      title: 'Business Consulting',
      description:
        'Strategic guidance to scale your business, optimize operations, and achieve sustainable growth with data-driven insights and proven methodologies.',
      color: 'primary-sage',
      delay: 0.2,
    },
    {
      icon: 'ri-shopping-cart-line',
      title: 'E-commerce Management',
      description:
        'Comprehensive e-commerce solutions from store setup to optimization, inventory management, and conversion strategies that drive sales.',
      color: 'primary-gold',
      delay: 0.4,
      featured: true,
    },
    {
      icon: 'ri-heart-pulse-line',
      title: 'Health & Wellbeing Coaching',
      description:
        'Holistic wellness programs designed to help you achieve balance, improve health habits, and maintain sustainable lifestyle changes.',
      color: 'primary-sage',
      delay: 0.6,
    },
  ];

  return (
    <section ref={ref} className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <div className="inline-flex items-center space-x-2 bg-accent-light-sage px-4 py-2 rounded-full mb-4">
            <span className="text-sm font-medium text-primary-sage">What I Offer</span>
          </div>
          <h2 className="font-serif font-bold text-4xl lg:text-5xl text-primary-charcoal mb-4">
            Three Pillars of Growth
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 50 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6, delay: service.delay }}
              whileHover={{ y: -8 }}
              className={`relative bg-primary-beige rounded-3xl p-8 transition-all duration-300 hover:shadow-2xl ${
                service.featured ? 'border-2 border-primary-gold lg:transform lg:-translate-y-4' : ''
              }`}
            >
              {service.featured && (
                <div className="absolute -top-3 left-1/2 transform -translate-x-1/2 bg-primary-gold text-white px-4 py-1 rounded-full text-xs font-semibold whitespace-nowrap">
                  Most Popular
                </div>
              )}

              <div className={`w-16 h-16 flex items-center justify-center bg-${service.color} rounded-full mb-6`}>
                <i className={`${service.icon} text-3xl text-white`}></i>
              </div>

              <h3 className="font-serif font-bold text-2xl text-primary-charcoal mb-4">
                {service.title}
              </h3>

              <p className="text-gray-600 leading-relaxed mb-6">{service.description}</p>

              <Link
                to="/services"
                className="inline-flex items-center text-primary-gold hover:text-accent-warm-gold font-semibold transition-colors cursor-pointer whitespace-nowrap"
              >
                Learn More
                <i className="ri-arrow-right-line ml-2"></i>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesOverview;
